import { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Dialog,
  DialogContent,
  Button,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseExpressReport } from "./UseExpressReport";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ListAltIcon from "@mui/icons-material/ListAlt";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function ExpressOrderReport() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const {
    getExpressList,
    updateAllAlopeykOrder,
    updateAlopeykOrder,
    GetAccountCredit,
  } = UseExpressReport();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Id", "Desc");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [accountRes, setAccountRes] = useState({ show: false, message: "" });
  const [expressRes, setExpressRes] = useState();
  const searchRef = useRef("");

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getExpressList(
      myPc,
      search,
      (expresss) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(expresss.pageCondition.totalPage);
          return;
        }
        setExpressRes(expresss);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
    },
    {
      field: "fullName",
      headerName: "نام مشتری",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiLogDate",
      headerName: "تاریخ",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiLogDate}
          </Typography>
        );
      },
    },
    {
      field: "state",
      headerName: "وضعیت",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.state}
          </Typography>
        );
      },
    },
    {
      field: "logesticName",
      headerName: "لجستیک",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.logesticName}
          </Typography>
        );
      },
    },
    {
      field: "logesticStateTitle",
      headerName: "وضعیت لجستیک",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.logesticStateTitle}
          </Typography>
        );
      },
    },
    {
      field: "totalPayment",
      headerName: "مجموع",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.totalPayment
              ? toMoney(cellValues.row.totalPayment)
              : ""}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="جزئیات">
              <IconButton
                onClick={() => {
                  return navigate(
                    `/expressorderreports/orderDetail?oid=${cellValues.row.id}`,
                    {
                      state: {
                        myPc: myPc,
                        search: search,
                      },
                    }
                  );
                }}
              >
                <ListAltIcon color="secondary" fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="رفرش">
              <IconButton
                onClick={() => {
                  setProgress(true);
                  let state = { id: cellValues.row.logesticID };
                  updateAlopeykOrder(state, () => {
                    getExpressList(
                      myPc,
                      search,
                      (expresss) => {
                        setExpressRes(expresss);
                      },
                      false
                    );
                  });
                }}
              >
                <RefreshIcon color="secondary" fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            fullWidth
            defaultValue=""
            onInput={(e) => {
              if (e.target.value == "") {
                handleSearch("");
              }
              searchRef.current = e.target.value;
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(searchRef.current);
              }
            }}
          />
        );
      },
    },
  ];

  const newFunc = () => {
    setProgress(true);
    updateAllAlopeykOrder((callback) => {
      getExpressList(
        myPc,
        search,
        (expresss) => {
          setExpressRes(expresss);
        },
        false
      );
    });
  };

  const newFuncAccount = () => {
    setProgress(true);
    let state = { LogesticID: 2 };
    GetAccountCredit(state, (callback) => {
      setAccountRes({ show: true, message: callback });
    });
  };

  return (
    <Detail
      breadChilds={{
        updateAll: {
          onclick: newFunc,
          account: {
            onclickAccount: newFuncAccount,
          },
        },

        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/expressorderreports" }],
      }}
    >
      {expressRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={expressRes.pageCondition.pageCount}
          rows={expressRes.items}
          paginationMode="server"
          page={expressRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            expressRes?.pageCondition.totalItemCount
              ? expressRes.pageCondition.totalItemCount
              : 0
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              nofab: true,

              rowCount: expressRes?.pageCondition.totalItemCount
                ? expressRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <Dialog
        BackdropProps={{
          style: {
            // backgroundColor: "transparent",
          },
        }}
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={accountRes.show}
        onClose={() => setAccountRes({ message: "", show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography id="alert-dialog-description">
            {accountRes.message}
          </Typography>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setAccountRes({ message: "", show: false })}
          >
            بستن
          </Button>
        </DialogContent>
      </Dialog>
    </Detail>
  );
}
